import React from 'react';
import RegisterCompany from 'pages/account/RegisterCompany';
import FindCompany from 'components/company/FindCompany';
import styled from 'styled-components';
import { Aside, Container, MainView } from 'styles/Styles.styled';
import { Link, useParams } from 'react-router-dom';
import { EpdLinks } from 'routes/EpdRoutes';

const CreateOrFindCompany: React.FunctionComponent = () => {
  const { tab } = useParams<{ tab: 'create' | 'connect' | undefined }>();

  const tabs: { name: string; key: 'create' | 'connect'; component: React.ReactNode }[] = [
    { name: 'Register organisation', key: 'create', component: <RegisterCompany /> },
    { name: 'Find organisation', key: 'connect', component: <FindCompany /> },
  ];

  const activeTabKey = tab || 'connect';
  const activeTab = tabs.find((t) => t.key === activeTabKey) || tabs[0];

  return (
    <div>
      <Container>
        <MainView>
          <Tabs>
            {tabs.map((tabItem) => (
              <TabLink key={tabItem.key} to={EpdLinks.organisation(tabItem.key)} $active={tabItem.key === activeTabKey}>
                {tabItem.name}
              </TabLink>
            ))}
          </Tabs>
          {activeTab.component}
        </MainView>
        <Aside style={{ backgroundColor: 'white' }}> </Aside>
      </Container>
    </div>
  );
};

const Tabs = styled.div`
  display: flex;
  flex-direction: row;
  border-bottom: solid 3px ${(props) => props.theme.colors.gray};
`;

const TabLink = styled(Link)<{ $active?: boolean }>`
  padding: 1rem;
  margin-right: 1px;
  background-color: ${(props) => (props.$active ? props.theme.colors.gray : 'white')};
  border: solid 1px ${(props) => props.theme.colors.gray};
  border-top: solid 3px ${(props) => props.theme.colors.regionColorLight};
  cursor: pointer;
  text-decoration: none;
  color: inherit;
  &:hover {
    border-top-color: ${(props) => props.theme.colors.regionColor};
  }
`;

export default CreateOrFindCompany;
